// extracted by mini-css-extract-plugin
module.exports = {"container":"TransactionCardTemplate_container_2Nfkt","title":"TransactionCardTemplate_title_2jBOZ","subtitle":"TransactionCardTemplate_subtitle_vqo7I"};